import request from '../../../../api/request';
import {
  PrimaryFiltersOptions,
  StudentsRiskHistory,
  StudentsRiskHistoryDetails,
  StudentsRiskHistoryDetailsRouteParams,
  StudentsRiskHistoryParams,
} from './types';

export const STUDENT_RISK_HISTORY = {
  GET_PRIMARY_FILTERS_OPTIONS: () =>
    `/maintainers-portal/student-risk-history/primary-filters`,
  GET_STUDENTS_RISK_HISTORY: () =>
    `/maintainers-portal/student-risk-history/students-list`,
  GET_STUDENTS_RISK_HISTORY_DETAILS: `/maintainers-portal/student-risk-history/students-details`,
  EXPORT_STUDENTS_RISK_HISTORY: () =>
    `/maintainers-portal/student-risk-history/export`,
};

export function getPrimaryFiltersOptions() {
  return request<PrimaryFiltersOptions>(
    STUDENT_RISK_HISTORY.GET_PRIMARY_FILTERS_OPTIONS(),
  );
}

export function getStudentsRiskHistory(params: StudentsRiskHistoryParams) {
  return request<StudentsRiskHistory>(
    STUDENT_RISK_HISTORY.GET_STUDENTS_RISK_HISTORY(),
    {
      params,
    },
  );
}

export function getStudentsRiskHistoryDetails(
  params: Partial<StudentsRiskHistoryDetailsRouteParams>,
) {
  return request<StudentsRiskHistoryDetails>(
    STUDENT_RISK_HISTORY.GET_STUDENTS_RISK_HISTORY_DETAILS,
    {
      params,
    },
  );
}

export type ExportStudentsRiskHistoryParams = {
  schoolId: number;
  year: number;
  periodId: number;
};

export function exportStudentsRiskHistory(
  params: ExportStudentsRiskHistoryParams,
) {
  return request<BlobPart>(
    STUDENT_RISK_HISTORY.EXPORT_STUDENTS_RISK_HISTORY(),
    {
      responseType: 'blob',
      params,
    },
  );
}
